<div class="app-page rankinglist">
  <mat-toolbar>
    <button mat-icon-button routerLink="..">
      <mat-icon>
        arrow_back_ios_new
      </mat-icon>
    </button>
    <button mat-stroked-button (click)="addPlayer()" [disabled]="!(_list?.IsMyList || _list?.CanEdit)">
      <mat-icon>
        add
      </mat-icon>
      PLAYER
    </button>
    <button matIconButton [matMenuTriggerFor]="menu" style="margin-left: auto;" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu" >
      @if (_list; as list) {
        <button  mat-menu-item [routerLink]="['/lists/edit', list.ListId]" [disabled]="!(list.IsMyList || list.CanEdit)">
          <mat-icon>
            edit
          </mat-icon>
          <span>{{'GENERAL.EDIT' | translate | uppercase  }}</span>
        </button>
        <button  mat-menu-item (click)="copyList();">
          <mat-icon>
            content_copy
          </mat-icon>
          <span>{{'GENERAL.COPY' | translate | uppercase  }}</span>
        </button>
        @if (!list.Archived) {
          <button   mat-menu-item (click)="archiveList();" [disabled]="!(list.IsMyList || list.CanEdit)">
            <mat-icon>
              archive
            </mat-icon>
            <span>{{'RANKINGLISTS.TO_ARCHIVE' | translate | uppercase}} - {{list.Archived}}</span>
          </button>
        }
        @if (list.Archived) {
          <button  mat-menu-item (click)="unarchiveList();" [disabled]="!(list.IsMyList || list.CanEdit)">
            <mat-icon>
              unarchive
            </mat-icon>
            <span>{{'RANKINGLISTS.TO_UNARCHIVE' | translate | uppercase}} - {{list.Archived}}</span>
          </button>
        }
        <button  mat-menu-item color="warn" (click)="deleteList();" [disabled]="!(list.IsMyList || list.CanEdit)" STYLE="color: red;">
          <mat-icon STYLE="color: red;">
            delete
          </mat-icon>
          <span>{{'GENERAL.DELETE' | translate | uppercase  }}</span>

        </button>
      }
    </mat-menu>
  </mat-toolbar>
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" style="position: fixed; top: 64px; left: 0; right: 0; z-index: 10;"></mat-progress-bar>
  }
  <div style="display: flex; flex-direction:column; height: 100%;" >
    @if (_list) {
      <div >
        <mat-list>
          <mat-list-item>
            <mat-icon matListItemIcon style="font-size: 24px; padding-bottom: 24px;" >format_list_numbered</mat-icon>
            <span matListItemTitle>{{_list.Description}}</span>
            <span matListItemLine><mat-icon style="font-size: small; height: 13px;width: 13px;">person</mat-icon> {{_list.CreatedBy}} </span>
            <!--  <h4 mat-line><b></b></h4>
            <p mat-line></p> -->
            @if (_list.Category) {
              <span matListItemLine><mat-icon style="font-size: small; height: 13px;width: 13px;">category</mat-icon> {{_list.Category}} </span>
            }
          </mat-list-item>
        </mat-list>
      </div>
    }
    <mat-divider></mat-divider>
    <!--  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)" *ngIf="_list.players">
    <div *ngIf="_list.players.length==0" style="margin-left: 5px; color:gray;">
      No players in list
    </div>
    <div class="example-box" *ngFor="let player of _list.players; let i=index" cdkDrag  [cdkDragDisabled]="_list.IsMyList===false">

      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <div cdkDragHandle style="font-weight: bold; width: 30px; font-size: large; font-family: Roboto; flex-grow: 1;" >
        {{i+1}}
      </div>
      <div class="listitem" style="flex-grow: 10;" (click)="this.selectedPlayer=player.Player.LifelineScoutingId">
        {{player.Player.LastName}}, {{player.Player.FirstName}}<br/>
        <span style="font-size: small;">{{player.Player.DateOfBirth | date: 'yyyy-MM-dd'}}</span>
        <div style="display: flex;">
          <mat-icon> rate_review </mat-icon>&nbsp;
          <label>{{player.NoOfReports}} </label>&nbsp;
          <mat-icon>note</mat-icon>&nbsp;{{player.NoOfNotes}}</div>
        </div>
        <button mat-icon-button *ngIf="_list.IsMyList==true" style="flex-grow: 1;" >
          <mat-icon>delete</mat-icon>
        </button>

      </div>
    </div>  -->
  </div>
  <mat-action-list cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!(_list?.IsMyList || _list?.CanEdit)">
    @for (player of (_list?.players ?? []); track player; let i = $index) {
      <a mat-list-item [routerLink]="['/lists/player', player.Player.LifelineScoutingId]">
        <div matListItemMeta>
          <button mat-icon-button (click)="confirmDelete(player.Player.LifelineScoutingId); $event.preventDefault(); $event.stopPropagation();" [disabled]="!(_list?.IsMyList || _list?.CanEdit)">
            <mat-icon>delete</mat-icon>
          </button>

        </div>
        <div matListItemTitle cdkDrag [cdkDragDisabled]="!(_list?.IsMyList || _list?.CanEdit)">
          <span>{{i+1}}</span>
          <mat-icon style="font-size: 32px; margin: 5px;" cdkDragHandle>drag_handle</mat-icon>
          {{player.Player.LastName}}, {{player.Player.FirstName}}
        </div>
        <div matListItemLine>
          {{player.Player.DateOfBirth | date:'yyyy-MM-dd'}} | {{player.NoOfReports}} {{"REPORTS.REPORTS" | translate | lowercase}} | {{player.NoOfNotes}} {{"REPORTS.NOTES" | translate | lowercase}}
        </div>

      </a>


    }
    @empty {
    <div style="margin-left: 5px; color:gray;">
      {{ "RANKINGLISTS.NOPLAYERSINLIST" | translate  }}
    </div>
  }
</mat-action-list>
<!-- <div style="display: flex; flex-direction: row; height: 95%;" >
<div style=" overflow-y: scroll; background-color: #303030; min-width: 330px; max-width: 330px; " *ngIf="_list">
  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)" *ngIf="_list.players">
    <div *ngIf="_list.players.length==0" style="margin-left: 5px; color:gray;">
      No players in list
    </div>
    <div class="example-box" *ngFor="let player of _list.players; let i=index" cdkDrag  [cdkDragDisabled]="_list.IsMyList===false">

      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <div cdkDragHandle style="font-weight: bold; width: 30px; font-size: large; font-family: Roboto; flex-grow: 1;" >
        {{i+1}}
      </div>
      <div class="listitem" style="flex-grow: 10;" (click)="this.selectedPlayer=player.Player.LifelineScoutingId">
        {{player.Player.LastName}}, {{player.Player.FirstName}}<br/>
        <span style="font-size: small;">{{player.Player.DateOfBirth | date: 'yyyy-MM-dd'}}</span>
        <div style="display: flex;">
          <mat-icon> rate_review </mat-icon>&nbsp;
          <label>{{player.NoOfReports}} </label>&nbsp;
          <mat-icon>note</mat-icon>&nbsp;{{player.NoOfNotes}}</div>
        </div>
        <button mat-icon-button *ngIf="_list.IsMyList " style="flex-grow: 1;" (click)="confirmDelete(player.Player.LifelineScoutingId)">
          <mat-icon>delete</mat-icon>
        </button>

      </div>
    </div>
  </div></div> -->


</div>

